import { mutations } from '@/features/_lib/react-query'
import type { TCreateAddressInputDTO } from '@doutorsim/shared/addresses'
import type { TExposedApplicationDTO } from '@doutorsim/shared/applications'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'
import { parseBirthDate } from '../_helpers/formatting'

interface UseConfirmDeclarationsArgs {
  application: TExposedApplicationDTO
}

interface ConfirmArgs {
  birthDate: string
  address: TCreateAddressInputDTO | null
}

export const useConfirmDeclarations = ({ application }: UseConfirmDeclarationsArgs) => {
  const queryClient = useQueryClient()

  const updateStatusMutation = useMutation(
    mutations.staffApplications.updateDeclarationsStatus(queryClient),
  )

  const confirm = async ({ birthDate, address }: ConfirmArgs) => {
    try {
      await updateStatusMutation.mutateAsync({
        applicationId: application.id,
        status: 'confirmed',
        confirmedData: {
          person: {
            birthDate: parseBirthDate(birthDate),
          },
          address,
        },
      })

      toast.success('Dados confirmados com sucesso')
    } catch {
      toast.error('Erro ao confirmar dados')
    }
  }

  const reject = async (reason: string) => {
    try {
      await updateStatusMutation.mutateAsync({
        applicationId: application.id,
        status: 'rejected',
        reason,
      })
      toast.success('Declarações rejeitadas')
    } catch {
      toast.error('Erro ao rejeitar declarações')
    }
  }

  return {
    confirm,
    reject,
    isPending: updateStatusMutation.isPending,
    isRejecting: updateStatusMutation.isPending,
  }
}
